<template>
  <v-container
    id="gdic-list"
    fluid
    tag="section"
  >
    <v-card>
      <v-card-title>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="検索！検索！"
          single-line
          hide-details
        />
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="words"
        :search="search"
        :items-per-page="30"
        class="elevation-1"
      />
    </v-card>
  </v-container>
</template>

<script>
  import axios from 'axios'
  // import TooltipButton from '@/views/dashboard/components/parts/TooltipButton.vue'
  export default {
    name: 'GDicWordsList',
    data () {
      return {
        api: 'http://anemoarchon.s205.xrea.com/api/gdic/',
        search: '',
        headers: [
          {
            text: 'よみ',
            align: 'start',
            sortable: true,
            value: 'yomi',
          },
          {
            text: '変換',
            align: 'left',
            sortable: true,
            value: 'word',
          },
          {
            text: '品詞',
            align: 'left',
            sortable: true,
            value: 'pos',
          },
          {
            text: 'カテゴリ',
            align: 'left',
            sortable: true,
            value: 'category',
          },
          {
            text: 'コメント',
            align: 'left',
            sortable: true,
            value: 'comment',
          },
          {
            text: '出典',
            align: 'left',
            sortable: true,
            value: 'source',
          },
          {
            text: '関連リンク',
            align: 'left',
            sortable: true,
            value: 'url',
          },
        ],
        words: [
          { yomi: '', word: '', category: '', comment: '', source: '', url: '' },
        ],
      }
    },

    mounted: function () {
      axios.get(this.api + 'list/selection')
        .then(response => {
          this.words = response.data
          for (const key in this.history) {
            this.words[key] = '<v-btn>' + this.words[key] + '</v-btn>'
            // this.words[key].url = '<TooltipButton label="外部リンク" />'
          }
        })
    },

    methods: {
      complete (index) {
        this.list[index] = !this.list[index]
      },
      execApi (url) {
        return axios({
          url: url,
          method: 'GET',
          responseType: 'arraybuffer',
          responseEncoding: 'binary',
        })
      },
    },
  }
</script>
